import React from 'react';
import {appGetUrlPath} from '../function_lib/common_lib';

export const Comp_Stu_Submit_Task=(props)=>{
  let appUrl=appGetUrlPath();
     //alert(JSON.stringify(props));

    //alert(JSON.stringify(props));
        return(<div className="modal fade bd-example-modal-xl"  id="divCompStuSubmitTask" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">{"Apply your Knowledge"}</h5>
              <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            <form id="frmCompStuSubmitTask" name="frmCompStuSubmitTask">
           
            <div className="modal-body">
            <div className="row">
                      {/* <!-- left column --> */}
                      <div className="col-md-12">
                          <div className="card card-danger">
                                   <div className="card-body">
                                    <textarea className='form-control' rows={"5"}>

                                    </textarea>


                                    
                                    
                                      <div className="col-md-6 respSSL"></div>
                                      <div id="testing2dd2222"></div>
                                  </div>
                              
                          </div>
                      </div>
                      <div className='col-md-4'>
                        <a href={"javascript:void(0)"}>
                        <i className='fa fa-keyboard-o fa-2x mr-5'></i>
                        </a>
                        <a href={"javascript:void(0)"}>
                        <i class="fa fa-camera fa-2x mr-5" aria-hidden="true"></i>
                        </a>
                        <a href={"javascript:void(0)"}>
                        <i class="fa fa-paperclip fa-2x" aria-hidden="true"></i>
                        </a>
                      </div>
                      <div className='col-md-1'>
                       
                      </div>
                      <div className='col-md-1'>
                     
                      </div>


                  </div>
            </div>
            <div className="modal-footer">
            <div onClick={()=>this.getCategories()}  style={{marginRight:"10px"}} id="btnCatSearch" name="btnCatSearch" className="btn btn-sm btn-danger">Submit Task</div>
                 <div onClick={()=>this.resetFilters()} className="btn btn-sm btn-primary">STO Approve</div>
            <div id="getReponse" style={{color:"red"}}></div>
             
            </div>
            </form>
          </div>
          </div>
          </div>
      );
    
}
export default Comp_Stu_Submit_Task;
